import { render, staticRenderFns } from "./item.vue?vue&type=template&id=1801ae19&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1801ae19')) {
      api.createRecord('1801ae19', component.options)
    } else {
      api.reload('1801ae19', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=1801ae19&", function () {
      api.rerender('1801ae19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/carousel/src/item.vue"
export default component.exports